import request from '../utils/request';
// 邮件发送 


export function sendEmail(data) {
  return request({
    url: '/frontExhibitor/zsEmail/sendEmail',
    method: 'post',
    data: data,
  });
}